import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as JobsStore from '../../store/jobs';
import { JobContractorSubRequests } from '../../components/jobs/JobContractorSubRequests';
import * as ContractorsStore from '../../store/contractors';

export default connect(
    (state: ApplicationState) => ({
        ...JobsStore.plainActions,
        constants: state.constants,
        ...state.identity,
        ...state.user,
        ...ContractorsStore.plainActions,
    }),
    JobsStore.actionCreators,
)(JobContractorSubRequests as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
